import { createContext, useContext } from 'react';
import { Location } from 'react-router';

export interface VideoManagerContextValue {
  advertiserPrettyId: string;
  advertiserUglyId: string;
  pathname: string;
  state?: { backgroundLocation?: Location };
  /** Page rendered behind the modal (from router state or the ?from= param). */
  backgroundLocation?: Location;
}

export const VideoManagerContext = createContext<VideoManagerContextValue>({
  advertiserPrettyId: '',
  advertiserUglyId: '',
  pathname: '',
  state: undefined,
  backgroundLocation: undefined,
});

export function useVideoManagerContext(): VideoManagerContextValue {
  return useContext(VideoManagerContext);
}
